"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var isString_1 = __importDefault(require("lodash/isString"));
var react_i18next_1 = require("react-i18next");
var react_bootstrap_1 = require("react-bootstrap");
var DpModalHeader_styled_1 = require("./DpModalHeader.styled");
var i18n_1 = require("../../../i18n");
var use_mount_hook_1 = require("../../../api/hooks/use-mount.hook");
(0, i18n_1.initI18n)();
var DpModalHeader = function (_a) {
    var children = _a.children, _b = _a.closeButton, closeButton = _b === void 0 ? true : _b, closeButtonAriaLabel = _a.closeButtonAriaLabel, _c = _a.firstFocusableElement, firstFocusableElement = _c === void 0 ? '.close' : _c;
    var t = (0, react_i18next_1.useTranslation)('common').t;
    var mainRef = (0, react_1.useRef)(null);
    (0, use_mount_hook_1.useMount)(function () {
        var _a;
        (_a = mainRef.current.querySelector(firstFocusableElement)) === null || _a === void 0 ? void 0 : _a.focus();
    });
    return ((0, jsx_runtime_1.jsx)(DpModalHeader_styled_1.StyledHeader, { closeButton: closeButton, closeLabel: closeButtonAriaLabel || t('closeModal'), ref: mainRef, "data-testid": "dp-modal-header", children: (0, isString_1.default)(children) ? (0, jsx_runtime_1.jsx)(react_bootstrap_1.Modal.Title, { as: "h2", children: children }) : (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: children }) }));
};
exports.default = DpModalHeader;
